/**
 * Label utility for schedule renderer views
 * Extracts the first label color for colored borders on schedule item cards.
 */

import type { ScheduleItemRow, ScheduleLabelRow } from "../../../../_logic/types/db-types";

/**
 * Returns the color of the first assigned label for a schedule item, or null if none
 * @param item - The schedule item
 * @param labelMap - Map of label ID to label row
 * @returns The hex color string or null
 */
export function getFirstLabelColor(item: ScheduleItemRow, labelMap: Map<number, ScheduleLabelRow>): string | null {
  for (const id of item.label_ids) {
    const label = labelMap.get(id);
    if (label?.color) return label.color;
  }
  return null;
}
